﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";
import DOMPurify from "dompurify";

import { toast, validRoles } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_incident } from "../incidents.constants";
import api from "@/services/api.service";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const IncidentsView = ({ customers, confirmSave }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, selected } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [data, setData] = useState({ ...base_incident });

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/incidencias");
	};

	const validSave = () => {
		if (!data.title) {
			toast(addToast, "Debe ingresar un título para guardar.", "error");
			return false;
		}

		if (!data.description) {
			toast(addToast, "Debe ingresar una descripción.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave({ form: data }, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setData({ ...base_incident });
	};

	const afterSave = () => {
		handleClose();
		addToast("Incidencia guardada correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && selected) {
			api.get("/admin/incidents/detail", { selected }).then((response) => {
				const { detail } = response;
				if (detail) {
					setData(detail);
				} else {
					addToast("Ocurrió un problema al cargar la incidencia seleccionada.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [selected, option]);

	return (
		<Modal show={option && option === "ver" ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form} size="lg">
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Incidencia</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<h4>{data.title ? data.title : ""}</h4>
						</Col>
						<Col md={12} xs={12}>
							<div className={classes.subtitle}>Descripción</div>
							<div
								className={"div_text_html"}
								dangerouslySetInnerHTML={{
									__html: data
										? DOMPurify.DOMPurify.sanitize(data.description, {
												ADD_TAGS: ["iframe"],
											})
										: "",
								}}
							/>
						</Col>
						<Col md={12} xs={12}>
							<div className={classes.subtitle}>Solución</div>

							<div
								className={"div_text_html"}
								dangerouslySetInnerHTML={{
									__html: data
										? DOMPurify.DOMPurify.sanitize(data.solution, {
												ADD_TAGS: ["iframe"],
											})
										: "",
								}}
							/>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Clientes</Form.Label>
								<Select
									isMulti
									value={data.customer_id ? customers.filter((c) => data.customer_id.includes(c.value)) : []}
									placeholder={<div>Clientes</div>}
									options={customers}
									onChange={(value) => {
										let newCustomers = [];

										value.forEach((customer) => {
											newCustomers.push(customer.value);
										});

										setData({
											...data,
											customer_id: newCustomers,
										});
									}}
									components={{
										NoOptionsMessage,
									}}
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						{"GUARDAR"}
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default IncidentsView;
